import { cn } from '@seen/ui'
import { IconClipboardHeart } from '@tabler/icons-react'

export function IconCarePlan({ className }: { className?: string }) {
  return <IconClipboardHeart className={cn('size-4 shrink-0', className)} />
}
